import { useTenant } from '../../context/TenantContext';

const UNEA_LOGO = 'https://www.uneatlantico.es/themes/uneatlantico/logo.svg';

export function LogoUNEA({ height = 32, style = {} }) {
  const tenant = useTenant();
  const src    = tenant?.logoUrl || UNEA_LOGO;
  const alt    = tenant?.name    || 'Universidad Europea del Atlántico';

  return (
    <img
      src={src}
      alt={alt}
      style={{ height, width: 'auto', maxWidth: '100%', objectFit: 'contain', display: 'block', ...style }}
    />
  );
}
